import api from 'api'

export type ListingViewsDataPoint = {
  date: string
  organicViews: number
  deeplinkViews: number
}

export type ListingViewsResponse = {
  listingId: number
  startDate: string
  endDate: string
  dataRefreshedAt: string | null
  listingViews: ListingViewsDataPoint[]
}

export async function getListingViews(
  listingId: number,
  timeRange: { startDate: string; endDate: string }
) {
  const response = await api.get<ListingViewsResponse>(
    `/admin/listing/${listingId}/views`,
    { params: timeRange }
  )
  return response.data
}
